// src/services/CountryService.js
import api from "./api";

export function getDegree(page = 1, limit = 10, search = "") {
    return api.get(`/degree?page=${page}&limit=${limit}&search=${search}`);
}

export function getDegreeById(id) {
    return api.get(`/degree/${id}`);
}

export function addDegree(data) {
    return api.post("/degree", data);
}

export function updateDegree(id, data) {
    return api.put(`/degree/${id}`, data);
}

export function deleteDegree(id) {
    return api.delete(`/degree/${id}`);
}
